import React from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { setupData } from "../../../configs/routes";
import {
	getDiseaseGroupCompany,
	getDiseaseName,
} from "../../../services/userService";
import { pathRoot } from "../Introduction";

export function Page1() {
	const headerDetails = {
		title: "Setup Intro/Disclaimer",
		currentPage: 1,
		pageCount: 3,
	};

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			backTo={setupData}
			nextTo={`${pathRoot}/2`}
		>
			<h2 className={"text-2xl font-bold mb-3"}>Introduction</h2>
			<p
				className={
					"mb-4 sm:mb-6 text-sm lg:text-base leading-tight lg:leading-6"
				}
			>
				{getDiseaseGroupCompany()} would like to invite{" "}
				{getDiseaseName().toLowerCase()} patients to use the Health Companion
				app.
			</p>

			<p className={"mb-4 text-sm lg:text-base leading-tight lg:leading-6"}>
				First and foremost, we want the Health Companion to be useful for you:
				recording your experience - and helping us to help you. It will only
				require a few minutes of your time each month. It will feed back to you
				the data you enter into it, and can assist you in communicating with
				care providers. It will be set up to remind you when it wants some input
				from you.
			</p>

			<p className={"mb-4 text-sm lg:text-base leading-tight lg:leading-6"}>
				No-one, apart from you, will ever see the specific data you record,
				unless you show them.
			</p>

			<p
				className={
					"mb-4 text-sm lg:text-base leading-tight lg:leading-6 sm:mb-6 "
				}
			>
				Use it regularly to describe what it's like to live with{" "}
				{getDiseaseName().toLowerCase()}: your symptoms, your experience of
				investigations and therapies, your quality of life, and how this
				fluctuates over time. We are also interested in what you as a family are
				having to spend on services and equipment in order to look after
				yourself.
			</p>

			<p
				className={
					"mb-4 text-sm lg:text-base leading-tight lg:leading-6 sm:mb-6 "
				}
			>
				This companion will enable {getDiseaseGroupCompany()} to inform
				healthcare providers about what is being done well, what could be
				improved and hopefully where there are variations in treatment
				healthcare. It will also assist {getDiseaseGroupCompany()} to develop
				its service to complement those of the NHS.
			</p>
		</SetupDataPageTemplate>
	);
}
